import { signal } from '@v3/ui'
import { inDiscord } from './activity-context.ts'

const ID_KEY = 'tabletop.v3.guest'
const NAME_KEY = 'tabletop.v3.name'

function mint(): string {
  const bytes = crypto.getRandomValues(new Uint8Array(12))
  return 'guest_' + [...bytes].map((b) => b.toString(36).padStart(2, '0')).join('').slice(0, 20)
}

function stored(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

function store(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // Private mode: identity lasts for this tab only.
  }
}

export let guestId: string = (() => {
  const existing = stored(ID_KEY)
  if (existing && /^guest_[a-z0-9]{8,32}$/.test(existing)) return existing
  const id = mint()
  store(ID_KEY, id)
  return id
})()

/** Activity identity comes from server-verified Discord OAuth, before any table is connected. */
export function setActivityIdentity(id: string): void {
  if (!/^guest_[a-z0-9]{8,32}$/.test(id)) throw new Error('Invalid Activity identity')
  guestId = id
}

export const displayName = signal(stored(NAME_KEY) ?? '')

export function setDisplayName(name: string): void {
  const clean = name.replace(/\s+/g, ' ').trim().slice(0, 24)
  displayName.set(clean)
  store(NAME_KEY, clean)
}

if (!inDiscord) document.cookie = `tt_guest=${guestId}; path=/; SameSite=Lax; max-age=31536000`
